import React, { useState, Fragment } from 'react';
import { navigate } from '@reach/router';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { Button, FormErrors } from '@squirrellearningltd/go-pupil-components';
import { X } from 'react-feather';
import { useMutation } from '@apollo/react-hooks';
import { STUDENT_ADD_READING_BOOK, ADD_NEW_READING_BOOK } from '../../../../services/graphql';
import { BOOK_TYPES } from '../../../../../../services/constants';
import BookItem from '../BookItem';
import BookDefaultCover from '../../../../../../components/BookDefaultCover';
import ReadingBookItem from '../../../../../Dashboard/components/ReadingBookItem';
import { MAIN_DASHBOARD_QUERY } from '../../../../../Dashboard/services/graphql';
import { useTranslation } from 'react-i18next';
import styles from './BookSearchResult.module.scss';

const BookSearchResult = ({ book, studentId }) => {

    const { t } = useTranslation();
    const [formErrors, setFormErrors] = useState([]);
    const [modalBookType, setModalBookType] = useState(null);

    const [studentAddReadingBook, { loading }] = useMutation(STUDENT_ADD_READING_BOOK, {
        update: (_, { data }) => {
            if (data.studentAddReadingBook.errors && data.studentAddReadingBook.errors.length !== 0) {
                setFormErrors(data.studentAddReadingBook.errors);
                return;
            } else if (data.studentAddReadingBook.studentReadingBook.id) {
                setModalBookType(null);
                navigate(`/book/${data.studentAddReadingBook.studentReadingBook.id}`);
            }
        },
        awaitRefetchQueries: true,
        refetchQueries: [{ query: MAIN_DASHBOARD_QUERY }]
    });

    const [studentAddNewReadingBook, { loading: newLoading }] = useMutation(ADD_NEW_READING_BOOK, {
        update: (_, { data }) => {
            if (data.addReadingBookAndAssignToStudent.errors && data.addReadingBookAndAssignToStudent.errors.length !== 0) {
                setFormErrors(data.addReadingBookAndAssignToStudent.errors);
                return;
            } else if (data.addReadingBookAndAssignToStudent.studentReadingBook.id) {
                setModalBookType(null);
                navigate(`/book/${data.addReadingBookAndAssignToStudent.studentReadingBook.id}`);
            }
        },
        awaitRefetchQueries: true,
        refetchQueries: [{ query: MAIN_DASHBOARD_QUERY }]
    });

    const { register, handleSubmit, errors } = useForm({
        validationSchema: Yup.object().shape({
            bookType: Yup.number().typeError(t('select_book_type'))
        })
    });

    const onSubmit = ({ bookType })=> {
        book.existsInDb ? 
            studentAddReadingBook({
                variables: {
                    bookId: book.id,
                    bookType
                }
            })
        :
            studentAddNewReadingBook({
                variables: {
                    studentId: studentId,
                    author: book.author,
                    title: book.title,
                    isbn: book.isbn,
                    isbn13: book.isbn13,
                    coverUrl: book.coverUrl,
                    description: "test description",
                    bookType,
                    hideComments: false,
                }
            })
    }

    return(
        <Fragment>
            <ReadingBookItem newBook={true} book={book} setModalBookType={setModalBookType} key={`book${book.id}`} />

            {modalBookType && (
                <div className={styles.bookSelectionModalOverlay}>
                    <div
                        aria-label={book.title}
                        aria-modal="true"
                        className={styles.bookSelectionModalDialog}
                        role="dialog"
                    >
                        <button
                            aria-label="Close book selection"
                            className={styles.bookSelectionModalClose}
                            onClick={() => setModalBookType(null)}
                            type="button"
                        >
                            <X />
                        </button>
                        <div className={styles.bookSelection}>
                            <div className={styles.bookSelectionCover}>
                                <BookDefaultCover coverUrl={book.coverUrl} alt={book.title} />
                            </div>
                            <div className={styles.bookSelectionContent}>
                                <BookItem book={book} showSelectBtn={false} modal />
                                <form className={styles.bookSelectionForm} onSubmit={handleSubmit(onSubmit)}>
                                    <label htmlFor="book-selection-type">
                                        {t('what_type_of_reading_book_would_you_like_to_add')}
                                    </label>
                                    <select id="book-selection-type" ref={register} name="bookType" className="basic-form__text-select">
                                        {BOOK_TYPES.filter(bookType => bookType.type !== 4).map(bookType => (
                                            <option key={bookType.type} value={bookType.type}>{t(bookType.extended_label)}</option>
                                        ))}
                                    </select>
                                    {errors.bookType && <p className="basic-form__hint">{errors.bookType.message}</p>}
                                    {formErrors.length !== 0 && <FormErrors errors={formErrors.map(error => t(error))} />}
                                    <Button className={styles.bookSelectionSubmit} type="submit" outline>
                                        {(loading || newLoading) ? t('adding') : t('add_book')}
                                    </Button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}

export default BookSearchResult;
